"use client";

import React from "react";

const Bookmark = ({ name }) => {
  return <span id={name}></span>;
};

export default Bookmark;
